module.exports = __webpack_public_path__ + "static/media/facebook.05f5e612.svg";